import CurrencyText from 'components/common/CurrencyText';
import ExtraDescriptionModal from 'components/common/ExtraDescriptionModal';
import BCheckbox from 'components/Form/BCheckbox';
import { extraUnitTypeLabels } from 'constants/extraUnitTypeLabels.constant';
import { ExtraUnitType } from 'enums/extraUnitTypes';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';
import { ExtraWithUnit } from 'types/vehicle.type';

interface PriceWidgetExtraSectionProps {
  getChecked: (id: number) => boolean;
  onChange: (isChecked: boolean, value: number) => void;
  getUnits: (id: number) => string;
  onUnitChange: (id: number, val: string) => void;
  list: ExtraWithUnit[];
  wrapperClass?: string;
  description?: string;
  disabled?: boolean;
  withPreline?: boolean;
}

const PriceWidgetExtraSection: FunctionComponent<
  PriceWidgetExtraSectionProps
> = ({
  getChecked,
  onChange,
  list,
  description,
  disabled,
  withPreline = false,
}) => {
  const { t } = useTranslation();

  return list.length ? (
    <div>
      {description ? (
        <span className="mb-2 block text-slate-500">{description}</span>
      ) : null}
      <div>
        {list.map((item) => (
          <div
            className="mb-5 flex flex-wrap items-start justify-between gap-1"
            key={item.id}
          >
            <div>
              <span className="!inline-flex items-center gap-1 !py-0.5">
                <BCheckbox
                  disabled={disabled}
                  checked={getChecked(item.id)}
                  value={item.id}
                  label={item.title}
                  onChange={(event) => onChange(event.target.checked, item.id)}
                />
                {!item.price ? (
                  <span className="text-sm text-slate-500">
                    {' '}
                    /
                    {t(
                      extraUnitTypeLabels[item.unit || ExtraUnitType.HEAD_COUNT]
                    )}
                  </span>
                ) : null}
              </span>
              {item.description ? (
                <span>
                  <ExtraDescriptionModal
                    description={item.description}
                    extraName={item.title}
                    modalClass="h-screen"
                    withPreline={withPreline}
                  />
                </span>
              ) : null}
            </div>
            {item.price ? (
              <div className="ml-auto">
                <CurrencyText
                  price={item.price.amount}
                  currency={item.price.currency}
                />
                {
                  <span className="text-sm text-slate-500">
                    {' '}
                    /
                    {t(
                      extraUnitTypeLabels[item.unit || ExtraUnitType.HEAD_COUNT]
                    )}
                  </span>
                }
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default PriceWidgetExtraSection;
